// src/features/chales/components/AddCreditModal.jsx
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Button } from "components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "components/ui/dialog";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { formatDateToYYYYMMDD } from "utils/dateUtils";

function AddCreditModal({ isOpen, onClose, onConfirm, initialData }) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (isOpen && initialData) {
      setValue("name", initialData.guestInfo);
      setValue("phone", initialData.phoneInfo);
      setValue("value", initialData.totalPaid);

      const today = new Date();
      const future = new Date(today.setMonth(today.getMonth() + 6));
      setValue("expirationDate", formatDateToYYYYMMDD(future));
    }
  }, [isOpen, initialData, setValue]);

  const onSubmit = (data) => {
    onConfirm({
      ...data,
      sourceReservationId: initialData.id,
    });
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Gerar Crédito</DialogTitle>
          <DialogDescription>
            Confirme os dados para gerar um crédito para este cliente.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid gap-4 py-4">
            {/* Campo Nome */}
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="name" className="text-right">
                Cliente
              </Label>
              <Input
                id="name"
                {...register("name", { required: "Nome é obrigatório" })}
                className="col-span-3"
              />
              {errors.name && (
                <p className="col-span-4 text-xs text-red-500 text-right -mt-2">
                  {errors.name.message}
                </p>
              )}
            </div>

            {/* Campo Telefone */}
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="phone" className="text-right">
                Telefone
              </Label>
              <Input
                id="phone"
                {...register("phone", { required: "Telefone é obrigatório" })}
                className="col-span-3"
              />
              {errors.phone && (
                <p className="col-span-4 text-xs text-red-500 text-right -mt-2">
                  {errors.phone.message}
                </p>
              )}
            </div>

            {/* Campo Valor */}
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="value" className="text-right">
                Valor (R$)
              </Label>
              <Input
                id="value"
                type="number"
                step="0.01"
                {...register("value", { required: "Valor é obrigatório" })}
                className="col-span-3 font-bold"
              />
              {errors.value && (
                <p className="col-span-4 text-xs text-red-500 text-right -mt-2">
                  {errors.value.message}
                </p>
              )}
            </div>

            {/* Campo Vencimento */}
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="expirationDate" className="text-right">
                Vencimento
              </Label>
              <Input
                type="date"
                id="expirationDate"
                {...register("expirationDate", {
                  required: "Data é obrigatória",
                })}
                className="col-span-3 force-light-datepicker"
              />
              {errors.expirationDate && (
                <p className="col-span-4 text-xs text-red-500 text-right -mt-2">
                  {errors.expirationDate.message}
                </p>
              )}
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit">Confirmar Crédito</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default AddCreditModal;
